import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Link, Route, Switch } from 'react-router-dom';
import { TERMS, COOKIE } from '../../../routes/paths';
import { getPathname } from '../../../modules/app/selectors';
import TermsAndConditions from '../TermsAndConditions';
import PrivacyPolicy from '../PrivacyPolicy';

const TABS = [
  {
    id: 'terms',
    label: 'Terms',
    path: TERMS
  },
  {
    id: 'cookie',
    label: 'Cookie',
    path: COOKIE
  }
];

class Tabs extends React.Component {
  static getCurrentTab(path) {
    const currentTab = TABS.find(t => t.path === path);
    return currentTab ? currentTab.id : null;
  }

  constructor(props) {
    super(props);
    this.selectTab = this.selectTab.bind(this);
    const current = Tabs.getCurrentTab(props.path);

    this.state = {
      current
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      current: Tabs.getCurrentTab(props.path)
    });
  }

  selectTab(index) {
    this.setState({
      current: index
    });
  }

  render() {
    const { current } = this.state;

    return (
      <div className="policies-tabs">
        <div className="container--fixed">
          <ul className="policies-tabs-bar">
            {
              TABS.map((tab) => (
                <li
                  key={tab.id}
                  className={classnames('policies-tabs-bar__item', {
                    'policies-tabs-bar__item--selected': tab.id === current
                  })}
                >
                  <Link className="policies-tabs-bar-item__link" to={tab.path}>
                    {tab.label}
                  </Link>
                </li>
              ))
            }
          </ul>
        </div>
        <div className="policies-tabs__content">
          <Switch>
            <Route path={TERMS} component={TermsAndConditions} />
            <Route path={COOKIE} component={PrivacyPolicy} />
          </Switch>
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  path: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  path: getPathname(state)
});

export default connect(mapStateToProps)(Tabs);
